import { RouterView } from 'vue-router';
export default function HrgsLeaveRoutes(staticTitle) {
    return [
        {
            path: '/hrgs/leave',
            name: 'hrgscuti',
            meta: {
                title: `${staticTitle} - HR & GS`
            },
            component: RouterView,
            children: [
                {
                    path: 'leave-request',
                    name: 'leaverequest',
                    meta: {
                        title: `${staticTitle} - HR & GS - Leave Request`
                    },
                    component: () => {
                        return import('@/views/hrgs/cuti/LeaveRequest.vue');
                    }
                },
                {
                    path: 'leave-request-site',
                    name: 'leaverequestsite',
                    meta: {
                        title: `${staticTitle} - HR & GS - Leave Request Site`
                    },
                    component: () => {
                        return import('@/views/hrgs/cuti/LeaveRequestSite.vue');
                    }
                },
                {
                    path: 'refund-tiket',
                    name: 'refundtiket',
                    meta: {
                        title: `${staticTitle} - HR & GS - Refund Ticket`
                    },
                    component: () => {
                        return import('@/views/hrgs/cuti/RefundTicket.vue');
                    }
                },
                {
                    path: 'tambah-tiket',
                    name: 'tambahtiket',
                    meta: {
                        title: `${staticTitle} - HR & GS - Additional Ticket`
                    },
                    component: () => {
                        return import('@/views/hrgs/cuti/AdditionalTicket.vue');
                    }
                }
            ]
        }
    ];
}
